// src/components/agent/AgentCard.jsx - Alternatif 1: Fokus Metrik
import React from 'react';
import { Link } from 'react-router-dom';
import Button from '../common/Button';
import { PlayCircleIcon, CpuChipIcon, AdjustmentsHorizontalIcon } from '@heroicons/react/24/outline';

const AgentCard = ({ agent }) => {
  const agentTypeName = agent.agent_type_name || agent.configuration?.serviceType || 'N/A';
  
  // Contoh metrik dummy (ganti dengan data asli jika ada)
  const usageLevel = agent.usageLevel || Math.floor(Math.random() * 100) + 1; // 1-100
  const capabilities = agent.capabilities || Math.floor(Math.random() * 3) + 2; // 2-5

  let usageColor = 'bg-green-500';
  if (usageLevel > 75) usageColor = 'bg-red-500';
  else if (usageLevel > 50) usageColor = 'bg-yellow-500';

  return (
    <div 
      className="
        bg-slate-800/70 backdrop-blur-lg 
        rounded-xl shadow-xl 
        border border-slate-700/50 
        p-5 flex flex-col justify-between 
        transition-all duration-300 ease-in-out
        hover:shadow-2xl hover:shadow-blue-500/30 hover:border-blue-500/70 transform hover:-translate-y-1
      "
    >
      <div>
        <div className="flex justify-between items-start mb-2">
          <h3 
            className="text-lg font-semibold text-slate-100 group-hover:text-blue-400 transition-colors duration-200 truncate" 
            title={agent.name}
          >
            <Link to={`/agent/${agent.agent_id}/run`} className="group-hover:text-blue-400">
                {agent.name || "Untitled Agent"}
            </Link>
          </h3>
          <span className="text-xs bg-slate-700 text-slate-300 px-2.5 py-1 rounded-full font-medium whitespace-nowrap">
            {agentTypeName}
          </span>
        </div>

        <p className="text-sm text-slate-400 mb-4 h-10 line-clamp-2">
          {agent.description || "No description for this agent."}
        </p>

        {/* Indikator Metrik/Status */}
        <div className="space-y-3 mb-5">
          <div>
            <div className="flex justify-between text-xs text-slate-400 mb-0.5">
              <span>Usage Level</span>
              <span>{usageLevel}%</span>
            </div>
            <div className="w-full bg-slate-700 rounded-full h-2.5">
              <div 
                className={`${usageColor} h-2.5 rounded-full transition-all duration-500 ease-out`} 
                style={{ width: `${usageLevel}%` }}
              ></div>
            </div>
          </div>
          <div>
            <div className="flex justify-between text-xs text-slate-400 mb-0.5">
              <span>Capabilities</span>
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <AdjustmentsHorizontalIcon key={i} className={`h-3.5 w-3.5 ${i < capabilities ? 'text-blue-400' : 'text-slate-600'}`} />
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-auto">
        <Link to={`/agent/${agent.agent_id}/run`}>
          <Button 
            variant="primary" 
            size="sm" 
            className="w-full flex items-center justify-center !py-2.5 text-sm bg-blue-500 hover:bg-blue-600 border-transparent"
          >
            <PlayCircleIcon className="h-5 w-5 mr-2" /> Run Agent
          </Button>
        </Link>
      </div>
    </div>
  );
};

export default AgentCard;